import { render, staticRenderFns } from "./ScadenzaDialog.vue?vue&type=template&id=59b02a75"
import script from "./ScadenzaDialog.vue?vue&type=script&lang=js"
export * from "./ScadenzaDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports